import styled from 'styled-components'

export const AlertBanner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  border: 1px solid #b6dbfb;
  border-radius: 8px;
  background: #e7f3fe;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    margin: 4px;
    font-size: 14px;
    color: #002a6d;
  }
`

export const AlertContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const AlertText = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-break: break-word;
`

export const AlertStrong = styled.strong`
  font-weight: 700;
`

export const AlertEmphasis = styled.span`
  color: #0085ff;
  font-weight: 400;
`

export const GuideLink = styled.a`
  color: #0085ff;
  font-weight: 400;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: #0085ff;
    text-decoration: underline;
  }
`
